import { render, staticRenderFns } from "./PremiumFinancePayment.vue?vue&type=template&id=208eb0a4"
import script from "./PremiumFinancePayment.vue?vue&type=script&lang=js"
export * from "./PremiumFinancePayment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports